import { StyledGrid } from '@Utils/styles';
import {
	useGlobalization,
	StylovyzeSearchBar,
	useCompanyDateTime,
	DataGridButton,
	DataGridButtonType,
} from '@innovyze/stylovyze';
import { Grid, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import React from 'react';
import { formatDateTimeWithFormatDate } from '@innovyze/lib-am-common/Utils';
import selectSearchValue from '@Selectors/util.selectors';
import { changeSearch, reloadRehabResult } from '@Actions/index';

interface TableToolbarProps {
	disable: boolean;
	showFilterPanel: () => void;
	refreshList: () => void;
	filterRef: React.RefObject<HTMLButtonElement>;
	lastRunCompleted?: string;
}

export const TableToolbar = ({
	disable,
	showFilterPanel,
	refreshList,
	lastRunCompleted,
	filterRef,
}: TableToolbarProps) => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const { formatDate } = useCompanyDateTime();
	const searchValue = selectSearchValue();

	const dispatchSearchFn = (text: string) =>
		dispatch(changeSearch({ search: text, forGroupResults: false }));

	const lastRunCompletedDiv = () => {
		if (lastRunCompleted && lastRunCompleted.length != 0)
			return (
				<div style={{ paddingTop: '6px' }}>
					{t('Results below were created on {{datetime}}', {
						datetime: formatDateTimeWithFormatDate(
							lastRunCompleted,
							formatDate,
						),
					})}
				</div>
			);
		else return [];
	};

	return (
		<StyledGrid
			alignItems="center"
			justifyContent="space-between"
			container
			style={{
				width: '100%',
				marginTop: '1rem',
				marginBottom: '1rem',
			}}>
			<Grid container item xs={4}>
				<Stack>
					<StylovyzeSearchBar
						onChange={(query: string) => {
							dispatchSearchFn(query);
							dispatch(reloadRehabResult());
						}}
						onRequestSearch={() => {
							dispatch(reloadRehabResult());
						}}
						onCancelSearch={() => {
							dispatchSearchFn('');
							dispatch(reloadRehabResult());
						}}
						placeholder={t('Search')}
						value={searchValue}
						dataCy={'search-01'}></StylovyzeSearchBar>
					{lastRunCompletedDiv()}
				</Stack>
			</Grid>
			<Grid
				item
				xs={8}
				container
				alignItems="center"
				justifyContent="flex-end"
				data-cy="grid-actionbutton"
				wrap="nowrap">
				<DataGridButton
					type={DataGridButtonType.FILTER}
					onClick={() => showFilterPanel()}
					disabled={disable}
					data-cy="filterButton"
					ref={filterRef}
				/>
				<DataGridButton
					type={DataGridButtonType.REFRESH}
					onClick={refreshList}
					disabled={disable}
					data-cy="refreshButton"
				/>
			</Grid>
		</StyledGrid>
	);
};
